exports = module.exports = require("../../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1tTXieIzDkszZ6a9GlnNnI{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;font-size:14px;font-weight:400}html[dir=ltr] .jynPF4oRwZ4mD2hD-DfTK{padding-right:8px}html[dir=rtl] .jynPF4oRwZ4mD2hD-DfTK{padding-left:8px}", ""]);
// Exports
exports.locals = {
	"previewBody": "_1tTXieIzDkszZ6a9GlnNnI",
	"previewSummaryPart": "jynPF4oRwZ4mD2hD-DfTK"
};